<script>
import resources from './resources'

export default {
  name: 'my-address',
  mixins: [resources]
}
</script>

<template lang="pug">
  .col-xl-4.col-lg-6.col-md-6.col-sm-12
    .card
      .header
        h2
          strong Unid: {{ item.unit.number }} -&nbsp;
          i.zmdi.zmdi-key(style="font-size: 1.0em;", v-if="item.available_for_rental === true") &nbsp;-&nbsp;
          | Torre: {{ item.tower.name }}

        ul.header-dropdown
          li.dropdown(:class="{'show': actions}")
            a.dropdown-toggle(
              href='javascript:void(0);',
               data-toggle='dropdown',
               role='button',
               aria-haspopup='true',
               aria-expanded='false'
               @click.prevent="viewActions(actions)"
            )
              i.zmdi.zmdi-more
            ul.dropdown-menu.dropdown-menu-righ(
              x-placement='bottom-end',
              style='position: absolute; transform: translate3d(-128px, 32px, 0px); top: 0px; left: 0px; will-change: transform;'
              :class="{'show': actions}"
            )
              li
                router-link.cursor-pointer(:to="{name: 'dweller.unit.edit', params: {id: item.id}}") Editar
              li
                 a(href='javascript:void(0);', @click.prevent="$emit('on-delete', item)") Excluir
      .body
        h6.m-b-15
          | Vaga(s):
          span.badge.badge-default.float-right(v-for="g in item.garage", style="margin-right: 4px;")
            | {{g.number}}
        ul.list-unstyled.team-info.m-t-20
          //-li.m-r-15
            small.text-muted Moradores
            img(src='',  title='Avatar', alt='Avatar')
</template>
<style scoped>
  .material-icons {
      font-family: 'Material Icons';
      font-weight: normal;
      font-style: normal;
      font-size: 12px;
      line-height: 1;
      letter-spacing: normal;
      text-transform: none;
      display: inline-block;
      white-space: nowrap;
      word-wrap: normal;
      direction: ltr;
      -webkit-font-feature-settings: 'liga';
      -webkit-font-smoothing: antialiased;
  }
  .cursor-pointer {
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/dweller/unit/index/components/item.vue